import { Menu, Modal } from '@mantine/core'
import PrimaryDropDown from 'app/views/components/DropDown/DropDown'
import { useDispatch } from 'react-redux'
import { LoanRolloverSplitParams } from 'app/models/loan-rollover-split-params'
import {
  approveLoanRolloverSplit,
  deleteLoanRolloverSplit,
  rejectLoanRolloverSplit,
  submitLoanRolloverSplit,
} from './rollover-split-daml-actions'
import { useState } from 'react'
import { useApprovedLoan } from '../loans/utilities/use-approved-loan'
import RolloverFormLogic from './rollover-form-logic'
import IonIcon from '@reacticons/ionicons'
import { LoanParams } from 'app/models/loan-params'
import DeleteConfirmation from 'app/views/components/delete-confirmation/DeleteConfirmation'
import { CenteredLoader } from 'app/views/components/loader/loader'

type Props = {
  row: LoanRolloverSplitParams
}

export default function LoanRolloverSplitActions({ row }: Props) {
  const resolveLoan = useApprovedLoan()
  const [loan, setLoan] = useState<LoanParams>()
  const [openForm, setOpenForm] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const dispatch = useDispatch()

  // Edit needs the split's loan: from the approved-loans slice when the page
  // has it, otherwise fetched by id (the Servicing page loads no loans up front).
  async function openSplitForm() {
    setLoan(undefined)
    setOpenForm(true)
    const resolved = await resolveLoan(row.loanId.id)
    if (!resolved) {
      setOpenForm(false)
      return
    }
    setLoan(resolved)
  }

  const handleDelete = async () => {
    await deleteLoanRolloverSplit(row, dispatch)
    setShowDeleteModal(false)
  }

  return (
    <div>
      <Modal
        size="50%"
        className="modal-body modal-body-template fit-content-modal"
        opened={openForm}
        onClose={() => setOpenForm(false)}
        styles={theme => ({
          content: {
            scrollbarWidth: 'thin',
            scrollbarColor: `${theme.colors.gray[4]} transparent`,
            '&::-webkit-scrollbar': { width: 6 },
            '&::-webkit-scrollbar-track': {
              backgroundColor: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: theme.colors.gray[4],
              borderRadius: 3,
            },
          },
        })}
      >
        {loan ? (
          <RolloverFormLogic loan={loan} close={() => setOpenForm(false)} />
        ) : (
          <CenteredLoader />
        )}
      </Modal>

      <Menu shadow="md" width={200} position="bottom" withinPortal>
        <Menu.Target>
          <div style={{ width: 'fit-content' }}>
            <PrimaryDropDown>Actions</PrimaryDropDown>
          </div>
        </Menu.Target>

        <Menu.Dropdown>
          {row?.status?.toLowerCase() === 'draft' ? (
            <Menu.Item
              icon={<IonIcon className="action-ion-icon" name="swap-horizontal-outline" />}
              onClick={() => openSplitForm()}
            >
              Edit
            </Menu.Item>
          ) : null}

          {row?.status?.toLowerCase() === 'draft' ? (
            <Menu.Item
              icon={<IonIcon className="action-ion-icon" name="swap-horizontal-outline" />}
              onClick={() => {
                submitLoanRolloverSplit(row, dispatch)
              }}
            >
              Submit For Approval
            </Menu.Item>
          ) : null}

          {row?.status?.toLowerCase() === 'submitted' ? (
            <Menu.Item
              icon={<IonIcon className="action-ion-icon" name="swap-horizontal-outline" />}
              onClick={() => {
                approveLoanRolloverSplit(row, dispatch)
              }}
            >
              Approve
            </Menu.Item>
          ) : null}

          {row?.status?.toLowerCase() !== 'approved' ? (
            <>
              <Menu.Divider />
              <Menu.Label>Danger zone</Menu.Label>
            </>
          ) : null}

          {row?.status?.toLowerCase() === 'draft' ? (
            <Menu.Item
              color="red"
              icon={<IonIcon className="action-ion-icon" name="trash-outline" />}
              onClick={() => setShowDeleteModal(true)}
            >
              Delete
            </Menu.Item>
          ) : null}

          {row?.status?.toLowerCase() === 'submitted' ? (
            <Menu.Item
              color="red"
              icon={<IonIcon className="action-ion-icon" name="swap-horizontal-outline" />}
              onClick={() => {
                rejectLoanRolloverSplit(row, dispatch)
              }}
            >
              Reject
            </Menu.Item>
          ) : null}
        </Menu.Dropdown>
      </Menu>

      {showDeleteModal && (
        <DeleteConfirmation
          onConfirm={handleDelete}
          onCancel={() => setShowDeleteModal(false)}
          message="Delete This Loan Rollover Split?"
        />
      )}
    </div>
  )
}
